import SelectionOfSuppliers from './SelectionOfSuppliers';

export default SelectionOfSuppliers;
